import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

import cardImg from "../../../../assets/images/studyCardImg.png";
import "./cardCourse.scss";
import { useNavigate } from "react-router-dom";

const CardCourse = ({ info }: any) => {
  const navigate = useNavigate();

  const courseClicked = () => {
    navigate(`/course/learn/${info.course_id}/${info.id}`);
  };
  return (
    <Card className={"card-course-wrapper"} sx={{ boxShadow: "none" }}>
      <CardMedia
        sx={{
          height: 162,
          "@media (max-width:1000px)": {
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            height: "100%",
            aspectRatio: "16/9",
          },
        }}
        image={cardImg}
        title="green iguana"
      />
      <CardContent onClick={() => courseClicked()}>
        <Box className={"card-course-title"}>{info.name}</Box>
        <Typography variant="body2" color="text.secondary">
          {info.fullname_teacher}
        </Typography>
        <Box className={"card-course-progress-bar"}>
          <Box
            className={"card-course-bar"}
            sx={{
              width: `${
                info.covered_material === 0 ? 1 : info.covered_material
              }%`,
            }}
          />
        </Box>
        <Box className={"card-course-progress-title"}>
          {info.covered_material === 0
            ? "Не начато"
            : `Завершено на ${info.covered_material}%`}
        </Box>
      </CardContent>
    </Card>
  );
};

export default CardCourse;
